import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../components/board/cp-board-routines.js';

@customElement('cp-page-board')
export class CpPageBoard extends LitElement {
  createRenderRoot() { return this; }

  render() {
    return html`
      <div class="cp-page cp-page-board">
        <h1 class="cp-page__title">Dashboard / Control Board</h1>
        <cp-board-routines></cp-board-routines>
        <cp-control-board></cp-control-board>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cp-page-board': CpPageBoard;
  }
}
